import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { DeviceSidebar } from '@/components/sidebar/DeviceSidebar';
import { SIDEBAR_WIDTH } from '@/config/constants';

interface AppShellProps {
  showSidebar?: boolean;
}

export function AppShell({ showSidebar = true }: AppShellProps) {
  return (
    <div className="flex h-screen flex-col">
      <TopBar />
      <div className="flex flex-1 overflow-hidden">
        {showSidebar && (
          <aside
            className="flex-shrink-0 border-r border-gray-200 bg-white"
            style={{ width: SIDEBAR_WIDTH }}
          >
            <DeviceSidebar />
          </aside>
        )}
        <main className="flex-1 overflow-auto bg-brand-ghost">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
